// extracted by mini-css-extract-plugin
export default {"main":"DashboardCard_main__1MXRn","value":"DashboardCard_value__AzU2b","name":"DashboardCard_name__qjhSU"};